import { baseTheme } from './base';
import { colors } from './colors';
import { createTransition } from './utils';
import { breakpoints, breakpointsMap } from './breakpoints';
import { buttons } from './buttons';

export const theme = {
  ...baseTheme,
  breakpoints,
  colors,
  buttons,
};

export { createTransition, breakpointsMap, breakpoints, colors };
